import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Header from '../../components/header/AdminHeader'
import Footer from '../../components/footer/Footer'
import useAdminRateStore from '../../stores/admin/rateStore'
import useToastStore from '../../stores/toastStore'

import { DataGrid, GridEditInputCell } from '@mui/x-data-grid'
import { styled } from '@mui/material/styles' // Sử dụng styled từ MUI v5

const CustomDataGrid = styled(DataGrid)(({ theme }) => {
    const pastelColors = {
        aqua: '#a7e6e6',
        yellow: '#fff9b3',
        green: '#b9f6b9',
    }

    return {
        '& .aqua-header': {
            backgroundColor: pastelColors.aqua,
        },
        '& .aqua-cell': {
            backgroundColor: pastelColors.aqua,
        },
        '& .yellow-header': {
            backgroundColor: pastelColors.yellow,
        },
        '& .yellow-cell': {
            backgroundColor: pastelColors.yellow,
        },
        '& .green-header': {
            backgroundColor: pastelColors.green,
        },
        '& .green-cell': {
            backgroundColor: pastelColors.green,
        },
    }
})
function EditInputCell(props) {
    const { error } = props

    return (
        <GridEditInputCell {...props} />
    )
}

function renderEditName(params) {
    return <EditInputCell {...params} />
}

export default function BasicEditingGrid() {
    const { fetchRates, rates, updateRate, validationErrors } = useAdminRateStore()
    const [rows, setRows] = useState([])
    const { addToast, removeToast } = useToastStore()
    const params = {}

    useEffect(() => {
        fetchRates(params)
    }, [fetchRates])

    useEffect(() => {
        setRows(rates)
    }, [rates])

    const preProcessEditCellProps = async (params) => {
        // console.log(validationErrors)
        // const errorMessage = await validateName(params.props.value.toString())
        return { ...params.props }
    }

    const columnDefs = [
        {
            headerName: 'Rate',
            field: 'name',
            width: 150,
            type: 'text',
            editable: false,
            headerClassName: 'aqua-header',
            cellClassName: 'aqua-cell',
        },
        {
            headerName: 'Value',
            field: 'value',
            width: 150,
            type: 'text',
            editable: true,
            preProcessEditCellProps,
            renderEditCell: renderEditName,
            headerClassName: 'yellow-header',
            cellClassName: 'yellow-cell',
        },
        {
            headerName: 'Last Update',
            field: 'updated_at',
            width: 200,
            type: 'text',
            editable: false,
            valueFormatter: (params) => {
              const date = new Date(params); // Chuyển ISO string sang Date object
              return date.toLocaleString('en-US', {
                timeZone: 'Asia/Bangkok',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
              });
            },
            headerClassName: 'green-header',
            cellClassName: 'green-cell',
        },
    ]

    const processRowUpdate = async (newRow) => {
        try {
            const res = await updateRate(newRow.id, newRow)
            if (res.success) {
                addToast('Update thành công!', 'success')
                // Cập nhật newRow với dữ liệu từ response
                const updatedRow = { ...newRow, ...res.data }

                // Cập nhật hàng với dữ liệu mới
                const updatedRows = rows.map((row) =>
                    row.id === newRow.id ? updatedRow : row
                )
                setRows(updatedRows)

                return updatedRow
            } else {
                removeToast()
                Object.keys(res.messages).forEach((key) => {
                    const errorMessages = res.messages[key].join(', ')
                    addToast(`${key}: ${errorMessages}`, 'danger')
                })

                // Nếu thất bại, trả về hàng ban đầu
                return newRow
            }
        } catch (error) {
            console.error('Failed to update the item:', error)
            throw error
        }
    }

    return (
        <div>
            <Header />
            <section className="tf-section-admin">
                <h2 class="tf-title-heading ct style-2 fs-30 mg-bt-10">Rates</h2>

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xl-4 col-lg-4 col-md-12">
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-12">
                            <div style={{ height: 'auto', width: '500px' }}>
                        <CustomDataGrid
                            initialState={{
                                sorting: {
                                    sortModel: [{ field: 'updated_at', sort: 'desc' }],
                                },
                            }}
                            rows={rows}
                            columns={columnDefs}
                            processRowUpdate={processRowUpdate}
                            hideFooterPagination={true}
                            editMode="row"
                            sx={{
                                borderColor: '#FFFFFF',
                                fontSize: 12,
                                fontWeight: 500,
                                '& .MuiDataGrid-cell': {
                                    color: 'black',
                                },
                                '& .MuiDataGrid-cell': {
                                    borderRight: '1px solid #ccc', // Đường viền giữa các ô dữ liệu
                                },
                                '& .MuiDataGrid-columnHeader': {
                                    borderRight: '1px solid #ccc', // Đường viền dưới tiêu đề cột
                                },
                                '& .MuiDataGrid-columnHeaders': {
                                    borderBottom: '2px solid #ccc', // Đường viền dưới tiêu đề cột
                                },
                                '& .MuiDataGrid-columnHeaderTitle': {
                                    fontWeight: 800,
                                },
                                '& .MuiInputBase-input': {
                                    fontSize: 12,
                                    color: '#14141f',
                                },
                                '.MuiDataGrid-row--editing .MuiDataGrid-cell': {
                                    fontSize: 12,
                                    color: '#14141f',
                                },
                                '.MuiDataGrid-footerContainer': {
                                    display: 'none',
                                }
                            }}
                        />
                    </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}
